import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const CollectionAlertsCard = ({ alerts }) => {
  const [showAll, setShowAll] = useState(false);
  const displayAlerts = showAll ? alerts : alerts.slice(0, 5);

  const getAlertIcon = (type) => {
    switch (type) {
      case "zero-collection":
        return "AlertCircle";
      case "low-collection":
        return "AlertTriangle";
      case "overdue":
        return "Clock";
      default:
        return "Info";
    }
  };

  const getAlertColor = (type) => {
    switch (type) {
      case "zero-collection":
        return "text-error";
      case "low-collection":
        return "text-warning";
      case "overdue":
        return "text-error";
      default:
        return "text-primary";
    }
  };

  const getAlertBgColor = (type) => {
    switch (type) {
      case "zero-collection":
        return "bg-error/10";
      case "low-collection":
        return "bg-warning/10";
      case "overdue":
        return "bg-error/10";
      default:
        return "bg-primary/10";
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const alertTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - alertTime) / (1000 * 60));

    if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    } else if (diffInMinutes < 1440) {
      return `${Math.floor(diffInMinutes / 60)}h ago`;
    } else {
      return `${Math.floor(diffInMinutes / 1440)}d ago`;
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Collection Alerts
          </h3>
          <p className="text-sm text-muted-foreground">
            Recent issues requiring attention
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-error rounded-full animate-pulse"></div>
          <span className="text-sm font-medium text-error">
            {alerts.length} Active
          </span>
        </div>
      </div>

      <div className="space-y-3">
        {displayAlerts.length > 0 ? (
          displayAlerts.map((alert) => (
            <div
              key={alert.id}
              className={`p-3 rounded-lg border ${getAlertBgColor(
                alert.type
              )} border-border`}
            >
              <div className="flex items-start space-x-3">
                <div
                  className={`flex items-center justify-center w-8 h-8 rounded-full ${getAlertBgColor(
                    alert.type
                  )}`}
                >
                  <Icon
                    name={getAlertIcon(alert.type)}
                    size={16}
                    className={getAlertColor(alert.type)}
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h4 className="text-sm font-medium text-foreground truncate">
                      {alert.company}
                    </h4>
                    <span className="text-xs text-muted-foreground">
                      {formatTimeAgo(alert.timestamp)}
                    </span>
                  </div>

                  <p className="text-sm text-muted-foreground mb-2">
                    {alert.message}
                  </p>

                  {alert.amount && (
                    <div className="flex items-center justify-between text-xs">
                      <span className="text-muted-foreground">
                        Outstanding:
                      </span>
                      <span className="font-medium text-foreground">
                        ₹{alert.amount.toLocaleString()}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <Icon
              name="CheckCircle"
              size={48}
              className="text-success mx-auto mb-3"
            />
            <p className="text-sm text-muted-foreground">No active alerts</p>
          </div>
        )}
      </div>

      {alerts.length > 5 && (
        <div className="mt-4 pt-4 border-t border-border">
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            onClick={() => setShowAll(!showAll)}
            iconName={showAll ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
            iconSize={14}
          >
            {showAll ? "Show Less" : `Show ${alerts.length - 5} More Alerts`}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CollectionAlertsCard;
